export default {
  女装: "Vêtements pour femmes",
  男装: "Pour des hommes",
  手机和小工具: "Téléphones portables et gadgets",
  居家生活: "la vie à la maison",
  电脑及周边设备: "Ordinateurs et équipements périphériques",
  美容及个人护理: "Beauté et soins personnels",
  家用电器: "appareils ménagers",
  健康与保健: "santé et bien-être",
  食品和饮料: "Nourriture et boissons",
  玩具_儿童和婴儿: "jouets, enfants et bébés",
  童装时尚: "mode enfant",
  视频游戏: "jeux vidéo",
  运动与户外: "Sports et plein air",
  爱好与书籍: "Loisirs et livres",
  相机和无人机: "Caméras et drones",
  宠物食品及用品: "Aliments et fournitures pour animaux de compagnie",
  女士包袋: "sacs pour femmes",
  男士包袋: "sacs pour hommes",
  珠宝及配饰: "Bijoux et Accessoires",
  手表: "montre",
  女鞋: "chaussures de femme",
  男装鞋: "chaussures pour hommes",
  汽车: "voiture",
  我附近的ShopeePay: "ShopeePay à proximité",
  餐饮_旅行和服务: "Restauration, voyages et services",
  旅行及行李: "Voyages et bagages",
  各种各样的: "Différentes sortes",
  我是来买什么的: "Qu'est-ce que je suis ici pour acheter ?",
  对不起_找不到_相关的商品: "Désolé, aucun produit lié à [{0}] trouvé",
  类别: "catégorie",
  产品: "produit",
  店铺: "boutique",
  首页: "page de garde",
  限时秒杀: "Vente flash à durée limitée",
  博客: "Blog",
  所有品牌: "Toutes les marques",
  所有类别: "Toutes catégories",
  我的购物车: "mon panier",
  发货信息: "Informations de livraison",
  交货信息: "Informations de livraison",
  付款: "Paiement",
  确认: "confirmer",
  您的购物车是空的: "Votre panier est vide",
  价格: "prix",
  税: "Impôt",
  数量: "quantité",
  总计: "total",
  移除: "Retirer",
  返回商店: "Retour au magasin",
  继续发货: "Continuer à expédier",
  筛选: "filtre",
  价格范围: "échelle des prix",
  排序方式: "Trier par",
  最新: "à jour",
  最旧: "le plus ancien",
  价格从低到高: "Prix ​​de faible à élevé",
  价格从高到低: "Prix ​​du plus cher au moins cher",
  选择交货类型: "Sélectionnez le type de livraison",
  送货上门: "Livraison",
  继续付款: "Continuez à payer",
  任何其他信息: "toute autre information",
  或者: "ou",
  您的钱包余额: "Solde de votre portefeuille",
  余额不足: "Solde insuffisant",
  支付: "payer",
  我同意: "Je suis d'accord",
  条款和条件: "termes et conditions",
  退货政策: "politique de retour",
  隐私政策: "politique de confidentialité",
  概括: "généraliser",
  项目: "projet",
  全部的: "tous",
  小计: "Total",
  总运费: "coût total d'expédition",
  有优惠码吗_在这里输入: "Y a-t-il un code de réduction ? entrer ici",
  申请: "Appliquer",
  编辑: "modifier",
  删除: "supprimer",
  添加新地址: "Ajouter une nouvelle adresse",
  继续交货信息: "Continuer les informations de livraison",
  选择一个地址: "Choisissez une adresse",
  购买历史: "Historique d'achat",
  下载: "télécharger",
  已发送退款请求: "Demande de remboursement envoyée",
  对比: "Par rapport",
  对话: "dialogue",
  我的钱包: "Mon sac à main",
  工单: "demande de service",
  管理个人资料: "Gérer le profil",
  登出: "se déconnecter",
  重置对比列表: "Réinitialiser la liste de comparaison",
  您的对比列表为空: "Votre liste de comparaison est vide",
  在您的购物车中: "dans votre panier",
  在您的愿望清单中: "dans votre liste de souhaits",
  在您的预定列表中: "sur votre liste de réservation",
  下载您的产品: "Téléchargez votre produit",
  选项: "Possibilités",
  什么都没找到: "rien n'a été trouvé",
  特色产品: "Produits populaires",
  最畅销: "Best-seller",
  前_名: "Haut {0}",
  查看更多: "voir plus",
  查看所有类别: "Voir toutes les catégories",
  十大品牌: "Dix grandes marques",
  查看所有品牌: "Voir toutes les marques",
  登录: "Se connecter",
  手机号码: "numéro de téléphone",
  密码: "mot de passe",
  密码长度为6到16个字符: "La longueur du mot de passe est de 6 à 16 caractères",
  验证码: "Le code de vérification",
  登录中: "Se connecter",
  游客登录: "Connexion visiteur",
  注册您的商店: "Enregistrez votre boutique",
  现在申请: "Appliquer maintenant",
  成为商家: "Devenez commerçant",
  现在注册: "S'inscrire maintenant",
  登录成功: "Atterri avec succès",
  通知: "notifier",
  未找到通知: "notification introuvable",
  评论: "Commentaire",
  估计运输时间: "Délai d'expédition estimé",
  天: "ciel",
  所售: "vendu",
  给商家留言: "Laisser un message au commerçant",
  规格: "spécification",
  库存: "en stock",
  总价: "prix total",
  添加到购物车: "Ajouter au panier",
  立即购买: "Achetez-le maintenant",
  缺货: "en rupture de stock",
  添加到愿望清单: "Ajouter à la liste de souhaits",
  加入对比列表: "Ajouter à la liste de comparaison",
  退款: "Remboursement",
  查看条款: "Voir les termes",
  分享: "partager",
  描述: "décrire",
  相关产品: "Produits connexes",
  没有人问过商家: "Personne n'a demandé aux marchands",
  该产品暂无评论: "Il n'y a pas encore de commentaire pour ce produit",
  客户评论: "Avis des clients",
  访问商店: "Visiter le magasin",
  畅销产品: "Meilleures ventes",
  日期: "date",
  订单编号: "numéro de commande",
  总额: "montant forfaitaire",
  状态: "État",
  愿望清单: "liste de souhaits",
  还没有添加任何东西: "Rien n'a encore été ajouté",
  注册: "registre",
  邀请码: "Code d'invitation",
  请输入邀请码: "Veuillez entrer le code d'invitation",
  用户名: "nom d'utilisateur",
  请输入用户名: "veuillez entrer le nom d'utilisateur",
  用户名长度为6_14个字符:
    "La longueur du nom d'utilisateur est de 6 à 14 caractères",
  昵称: "Surnom",
  请输入手机号码: "Veuillez entrer le numéro de téléphone",
  手机号码格式错误: "Mauvais format du numéro de téléphone",
  密码长度为6_16个字符: "La longueur du mot de passe est de 6 à 16 caractères",
  确认密码: "Confirmez le mot de passe",
  请输入确认密码: "Veuillez saisir le mot de passe de confirmation",
  提款密码: "Mot de passe de retrait",
  请输入提款密码: "Veuillez saisir le mot de passe de retrait",
  提款密码长度为4_16个字符:
    "La longueur du mot de passe de retrait est de 4 à 16 caractères",
  请输入验证码: "veuillez entrer le code de vérification",
  在_s后发送: "Envoyé après {0}s",
  发送验证码: "Envoyer le code de vérification",
  注册即表示您同意我们的条款和条件:
    "En vous inscrivant, vous acceptez nos termes et conditions.",
  创建账号: "Créer un compte",
  验证码发送成功: "Code de vérification envoyé avec succès",
  确认密码不一致: "Confirmez que le mot de passe est incohérent",
  提款密码必须为数字: "Le mot de passe de retrait doit être numérique",
  注册成功: "succès de l'inscription",
  购物车: "panier",
  账户: "Compte",
  我的账户: "Mon compte",
  已经有一个账户: "Vous avez déjà un compte",
  新地址: "nouvelle adresse",
  编辑地址: "Modifier l'adresse",
  保存: "sauvegarder",
  是否默认: "Est-ce la valeur par défaut",
  具体地址: "Adresse spécifique",
  请输入具体地址: "Veuillez entrer une adresse spécifique",
  地区: "zone",
  请输入地区: "Veuillez entrer la région",
  城市: "Ville",
  请输入城市: "Veuillez entrer la ville",
  省份: "province",
  请输入省份: "Veuillez entrer la province",
  邮政编码: "Code Postal",
  请输入邮政编码: "Veuillez entrer le code postal",
  电话号码: "numéro de téléphone",
  请输入电话号码: "Veuillez entrer votre numéro de téléphone",
  收货人: "Destinataire",
  请输入收货人: "Veuillez entrer le destinataire",
  保存成功: "Enregistré avec succès",
  最畅销的商家: "Marchands les plus vendus",
  查看所有的商家: "Voir toutes les entreprises",
  支持政策: "Politique d'assistance",
  您的电子邮件地址: "Votre adresse e-mail",
  订阅: "abonnement",
  联系方式: "Coordonnées",
  地址: "adresse",
  美国伊利诺伊州霍夫曼庄园: "Hoffman Estates, Illinois, États-Unis",
  快速链接: "Liens rapides",
  商家政策: "Politiques des commerçants",
  submit: "soumettre",
  提款银行卡: "Retrait carte bancaire",
  我的面板: "mon panneau",
  提示: "indice",
  确定登出吗: "Êtes-vous sûr de vouloir vous déconnecter?",
  确定: "Bien sûr",
  取消: "Annuler",
  项目添加到您的购物车: "Ajouter l'article à votre panier",
  经常一起购买: "achètent souvent ensemble",
  返回购物: "Retour aux achats",
  进行结算: "passer à la caisse",
  帮助热线: "Ligne d'assistance",
  查看所有通知: "Afficher toutes les notifications",
  请输入密码: "Veuillez entrer le mot de passe",
  前往充值: "Allez recharger",
  购物车物品: "Articles du panier",
  查看购物车: "vérifier le panier",
  钱包余额: "solde du portefeuille",
  充值钱包: "Recharger le portefeuille",
  钱包充值_线下_: "Recharge du portefeuille (hors ligne)",
  申请提款: "Demander le retrait",
  钱包收支明细: "Détails des revenus et dépenses du portefeuille",
  批准: "approuver",
  提现历史记录: "Historique des retraits",
  类型: "taper",
  信息: "information",
  付款方式: "mode de paiement",
  请选择付款方式: "Veuillez choisir un mode de paiement",
  Bill_Type_RECHARGE_BACK: "Recharge back-end",
  Bill_Type_RECHARGE_ONLINE: "Recharge en ligne",
  Bill_Type_RECHARGE_REGISTER: "Inscription gratuite",
  Bill_Type_RECHARGE_JACKPOT: "Bonus de recharge",
  Bill_Type_RECHARGE_PRESENT: "Recharger les récompenses",
  Bill_Type_RECHARGE_FROM_COMMISSION: "Transfert de commissions",
  Bill_Type_RECHARGE_TG_COMMISSION: "Commission de promotion de recharge",
  Bill_Type_REGISTER_TG_COMMISSION: "Commission de promotion des inscriptions",
  Bill_Type_WITHDRAW: "retirer",
  Bill_Type_WITHDRAW_REJECT: "Retrait rejeté",
  Bill_Type_DEDUCT_HANDLE: "Déduction manuelle",
  Bill_Type_DEDUCT_RECHARGE_MONEY: "Correction de recharge",
  Bill_Type_MINING_PROFIT: "Revenu minier",
  Bill_Type_MINING_PROFIT_COMMISSION:
    "Commission de promotion des revenus miniers",
  Bill_Type_VIP_UPGRADE: "Mettre à niveau VIP",
  Bill_Type_FINANCE_BUY: "Acheter des produits financiers",
  Bill_Type_FINANCE_CAPITAL_RETURN: "Retour de l'équilibre financier",
  Bill_Type_FINANCE_FEE: "Frais de gestion financière",
  Bill_Type_FINANCE_PROFIT: "Produits de gestion financière",
  Bill_Type_FINANCE_BUY_COMMISSION: "Commission d'achat de produits financiers",
  Bill_Type_FINANCE_PROFIT_COMMISSION:
    "Commission sur les revenus des produits financiers",
  Bill_Type_WHEEL_DRAW: "Loterie à grande roue",
  Bill_Type_BUY: "acheter des biens",
  Bill_Type_PAY_SHOP: "Payer l'expédition",
  Bill_Type_BUY_COMMISSION: "Commission sur les articles achetés",
  Bill_Type_DEPOSIT: "Payer un acompte",
  Bill_Type_STORE_BUY: "acheter des biens",
  Bill_Type_STORE_BUY_REFUND: "Remboursement du produit acheté",
  Bill_Type: "Type de changement de compte",
  Before_Money: "montant précédent",
  Deal_Money: "Montant du changement de compte",
  After_Money: "Montant après",
  Bill_Time: "Heure de changement de compte",
  No_More_Data: "plus de données",
  Apply_Money: "Montant de la demande",
  Apply_Time: "temps d'application",
  Withdraw_Info: "Frais de traitement : {fee}, arrivée : {money}",
  提款订单状态_CHECKING: "En attendant l'examen",
  提款订单状态_TRANSFERRING: "Transfert",
  提款订单状态_PASS: "confirmé",
  提款订单状态_REJECT: "Rejeté",
  暂无可用充值方式: "Aucune méthode de recharge disponible pour l'instant",
  钱包收款码: "Code de paiement du portefeuille",
  钱包地址: "adresse du portefeuille",
  金额限制: "Plafond de montant",
  复制: "copie",
  付款凭证: "bon de paiement",
  收款银行: "Banque bénéficiaire",
  收款人: "Bénéficiaire",
  收款账号: "Numéro de compte de paiement",
  付款银行: "banque de paiement",
  付款人: "Payeur",
  付款账号: "Compte de paiement",
  请输入付款银行: "Veuillez saisir la banque de paiement",
  请输入付款人: "Veuillez entrer le payeur",
  请输入付款账号: "Veuillez saisir le numéro de compte de paiement",
  请上传付款凭证: "Veuillez télécharger le bon de paiement",
  充值金额: "Montant de la recharge",
  请输入充值金额: "Veuillez saisir le montant de la recharge",
  submitting: "soumission...",
  Confirm: "soumettre",
  Commit_Success: "Soumis avec succès",
  balanceType_BALANCE: "Équilibre",
  balanceType_COMMISSION: "commission",
  Balance: "Solde du compte",
  Wash_Money: "ajouter une mosaïque",
  请选择银行账户: "Veuillez sélectionner un compte bancaire",
  卡号类型: "Type de numéro de carte",
  提现金额: "Montant de retrait",
  提款金额: "Montant de retrait",
  不能为空: "Ne peux pas être vide",
  金额不正确: "Le montant est incorrect",
  please_input_withdraw_password: "Veuillez saisir le mot de passe de retrait",
  withdraw_password_format_error:
    "Le mot de passe de retrait doit comporter de 4 à 16 caractères",
  Fee: "frais de gestion",
  实际到账: "Arrivée réelle",
  交易币种: "Devise de la transaction",
  原始密码: "mot de passe d'origine",
  confirm_password_error: "Le mot de passe saisi deux fois est incorrect",
  save_success: "Enregistré avec succès",
  please_input: "Entrez s'il vous plait",
  old_password: "ancien mot de passe",
  new_password: "nouveau mot de passe",
  please_input_confirm_password: "Veuillez confirmer à nouveau le mot de passe",
  没有找到符合条件的商品: "Aucun produit correspondant trouvé",
  Search: "recherche",
  全部: "tous",
  EnumGoodsOrderState_USER_PAY: "En attente de livraison",
  EnumGoodsOrderState_SHOP_PAY: "Livrer",
  EnumGoodsOrderState_SUCCESS: "Finition",
  EnumGoodsOrderState_CANCEL: "Annulé",
  EnumGoodsOrderState_REFUND_SUCCESS: "remboursé",
  订单号: "numéro de commande",
  用户名称: "nom d'utilisateur",
  收益: "revenu",
  支付时间: "Délai de paiement",
  配送时间: "Délai de livraison",
  完成时间: "Temps complet",
  发货: "Bateau",
  全选: "tout sélectionner",
  物品已添加到愿望清单: "Article ajouté à la liste de souhaits",
  物品已添加到比较列表: "Article ajouté à la liste de comparaison",
  购买成功提示: "Félicitations, votre achat est réussi",
  订单列表: "Liste de commande",
  商品名: "Nom du produit",
  图片: "image",
  没有品牌: "sans marque",
  基本信息: "Informations de base",
  Account_Name: "Nom d'ouverture du compte",
  Bank_Account: "Compte bancaire",
  Bank_Phone: "Réserver un numéro de téléphone portable",
  IFSC: "Compte IFSC",
  UPI: "Compte UPI",
  PIX: "Compte PIX",
  CPF: "Compte CPF",
  GCASH: "Compte GCASH",
  POWWI: "Compte POWWI",
  身份证号: "Numéro d'identification",
  Edit: "Réviser",
  Delete: "supprimer",
  Add: "Nouveau",
  Forget_Withdraw_Password: "Mot de passe de retrait oublié",
  Bank_Card_Info: "Informations sur la carte bancaire",
  收款人地址: "Adresse du bénéficiaire",
  SWIFT: "RAPIDE",
  Bank_Branch: "Nom de la filiale",
  分行代码: "code de succursale",
  银行地址: "adresse de la banque",
  Email: "E-mail",
  银行卡长度必须超过: "La longueur de la carte bancaire doit dépasser {length}",
  银行卡格式不正确: "Le format de la carte bancaire est incorrect",
  Do_you_confirm_delete: "Confirmer la suppression?",
  Please_Login_First: "s'il vous plait Connectez-vous d'abord",
  Bank_Name: "Nom de banque",
  Please_add_bank_first:
    "Vous n'avez pas encore lié votre carte bancaire, veuillez d'abord l'ajouter",
  withdrawType: "Type de retrait",
  withdraw_money_limit:
    "Le montant du retrait doit être supérieur à 0 et inférieur ou égal à {balance}",
  withdraw_times_limit:
    "Vous avez retiré {todayWithdrawNum} fois aujourd'hui, et des frais de traitement de {withdrawFee} % seront facturés après {limitTimes} fois. Etes-vous sûr de vous retirer ?",
  Copy_Success: "Copié avec succès",
  商店首页: "Page d'accueil du magasin",
  所有产品: "Tous les produits",
  新到货产品: "Produits nouvellement arrivés",
  所有商家: "Tous les commerçants",
  请上传: "Veuillez télécharger",
  请输入: "Entrez s'il vous plait",
  忘记密码: "oublier le mot de passe",
  记得我: "souviens-toi de moi",
  共_件: "Total de {0} éléments",
  取消订单: "annuler la commande",
  申请退款: "Demande à être remboursé",
  未知商家: "Marchand inconnu",
  到账: "Reçu",
  提款订单状态: "Statut de l'ordre de retrait",
  前_名类别: "Principales {0} catégories",
  取消订单原因_不想要了: "Je n'en veux plus",
  取消订单原因_商品错选_多选:
    "Mauvaise sélection de produits/sélections multiples",
  取消订单原因_商品无货: "Produit en rupture de stock",
  取消订单原因_地址信息填写错误: "Informations d'adresse mal renseignées",
  取消订单原因_商品降价: "Réduction du prix du produit",
  取消订单原因_价格高于其他平台:
    "Le prix est plus élevé que sur les autres plateformes",
  取消订单原因_没用_少用_错用优惠:
    "Pas d'utilisation/moins d'utilisation/abus des réductions",
  退款原因_拍错_多拍_不喜欢:
    "Mauvais coup / coup supplémentaire / je n'aime pas ça",
  退款原因_商品成分描述不符:
    "La description de l'ingrédient du produit ne correspond pas",
  退款原因_与商家协商一致退款: "Remboursement comme convenu avec le commerçant",
  退款原因_生产日期_保质期与商品描述不符:
    "La date de production/durée de conservation ne correspond pas à la description du produit",
  退款原因_图片_产地_批号_规格等描述不符:
    "Les images/origine d'origine/numéro de lot/spécifications et autres descriptions ne correspondent pas",
  退款原因_质量问题: "Problèmes de qualité",
  退款原因_商品变质_发霉_有异物:
    "Le produit est avarié/moisi/contient des corps étrangers",
  退款原因_少件_含缺少配件_:
    "Peu de pièces (y compris les accessoires manquants)",
  退款原因_收到商品时有破损_污渍_变形:
    "L'article a été endommagé/taché/déformé lors de sa réception.",
  退款原因_假冒品牌: "Marques contrefaites",
  退款原因_发票问题: "Problèmes de facture",
  退款原因_商家发错货: "Le commerçant a envoyé les mauvaises marchandises",
  退款原因_预约不到_商家不给退换:
    "Impossible de prendre rendez-vous/le commerçant ne vous accordera ni remboursement ni échange",
  退款失败: "Le remboursement a échoué",
  退款处理中: "Remboursement en cours",
  默认: "défaut",
  产品查询: "Recherche de produit",
  商店LOGO: "Logo du magasin",
  推广码: "Code promotionnel",
  查看所有: "Voir tout",
  确认收货成功: "Confirmer la réception des marchandises avec succès",
  物流公司: "Entreprise de logistique",
  物流单号: "numéro d'expédition",
  发货时间: "Temps d'expédition",
  请先选择商品规格:
    "Veuillez d'abord sélectionner les spécifications du produit",
  个人信息: "informations personnelles",
  您的用户名: "ton nom d'utilisateur",
  你的名字: "votre nom",
  登录名: "nom d'utilisateur",
  你的邮件: "votre email",
  你的密码: "votre mot de passe",
  重复输入密码: "Répéter le mot de passe",
  店铺名称: "Nom du magasin",
  证书类型: "Type de certificat",
  身份证: "Carte d'identité",
  护照: "passeport",
  驾驶执照: "le permis de conduire",
  社会保障卡: "Carte de sécurité sociale",
  证书正面: "Recto du certificat",
  证书反面: "Verso du certificat",
  确认收货: "confirmer la réception des marchandises",
  请选择取消订单的原因必选:
    "Veuillez sélectionner le motif de l'annulation de la commande (obligatoire) :",
  请选择申请退款的原因必选:
    "Veuillez sélectionner le motif de la demande de remboursement (obligatoire) :",
  留言: "message",
  请输入留言: "Veuillez entrer un message",
  没有帐户: "Pas de compte",
  钱包充值: "Recharge du portefeuille",
  输入您的文字: "Entrez votre texte",
  商家登录: "Connexion marchand",
  有关此产品的任何查询: "Toute demande de renseignements sur ce produit",
  产品名称: "nom du produit",
  你的问题: "ton problème",
  白银店铺: "boutique d'argenterie",
  铂金店铺: "magasin de platine",
  钻石店铺: "boutique de diamants",
  照片: "photo",
  已退货: "Revenu",
  邮寄状态: "Statut d'envoi",
  订单摘要: "Récapitulatif de la commande",
  收件地址: "Adresse du destinataire",
  订购日期: "Date de commande",
  订单状态: "Statut de la commande",
  总订单金额: "Montant total de la commande",
  邮寄方式: "Méthode d'envoi",
  附加信息: "Informations Complémentaires",
  订单详细信息: "Détails de la commande",
  交货类型: "Type de livraison",
  进行评论: "Faire un commentaire",
  已评论: "Commenté",
  订单金额: "montant de la commande",
  优惠券: "coupon",
  统一运费: "Frais d'expédition forfaitaires",
  送货地址: "adresse de livraison",
  评分: "score",
  你的意见: "votre opinion",
  匿名: "anonyme",
  现金: "espèces",
  详情: "Détails",
  收货地址: "Adresse de livraison",
  暂时没有对话: "Aucune conversation pour l'instant",
  你: "toi",
  输入您的回复: "Entrez votre réponse",
  删除成功: "supprimé avec succès",
  品牌: "marque",
  已缴纳的保证金: "Dépôt de garantie versé",
  黄金店铺: "magasin d'or",
  没有更多数据: "plus de données",
  站内信: "Message du site",
  系统通知: "notification du système",
  邮箱: "Mail",
  手机号: "Numéro de téléphone",
  你的手机号: "votre numéro de téléphone",
  营业执照: "licence d'exploitation",
  你的邮箱: "votre boîte aux lettres",
  搜索结果: "Résultats de recherche",
  系统公告: "notification du système",
  客服: "service client",
  消息已撤回: "Le message a été retiré",
  物流详情: "Détails logistiques",
  充值: "recharger",
  提现: "retirer",
  信用分: "pointage de crédit",
  余额: "équilibre",
  佣金: "commission",
  继续购物: "Continuer vos achats",
  订单结算: "Règlement des commandes",
  加入对比: "Ajouter à la comparaison",
  佣金余额: "Solde des commissions",
  刷新: "rafraîchir",
  刷新成功: "Actualisation réussie",
  官网: "Site officiel",
  税号: "Numéro d'identification fiscale",
  订单: "Commande",
  合计: "total",
  系统安全: "Sécurité du système",
  Recharge_Money_Limit:
    "Le montant de la recharge doit être compris entre {min} et {max}",
  限时优惠: "Offre à durée limitée",
  高价回收: "Un recyclage à prix élevé",
  姓名: "Nom",
  商品订单号: "Numéro de commande du produit",
  商品在线回收: "Recyclage des produits en ligne",
  提交: "soumettre",
  回收记录: "Dossiers de recyclage",
  回收状态: "Statut de recyclage",
  回收价格: "prix du recyclage",
  纳税码: "code des impôts",
  买家登录: "Se connecter",
  买家注册: "registre",
  language: "法语",
  助力提示:
    "Aider les commerçants peut augmenter l'exposition de la plate-forme à leurs magasins et plus le nombre cumulatif de jours est élevé, plus l'exposition est élevée.",
  已累计助力: "Assisté cumulativement",
  今日已助力: "Aujourd'hui a aidé",
  立即助力: "Aider immédiatement",
  商家助力: "Aide marchande",
  证件号码: "Numéro d'identification",
  证书号码: "Numéro de certificat",
  男鞋: "Chaussures pour hommes",
  游戏玩具: "Jouets de jeu",
  使用条款: "conditions d'utilisation",
  商家: "Marchand",
  已助力: "A aidé",
  被助力: "Être aidé",
  用户: "utilisateur",
  助力记录: "Aider à enregistrer",
  消息类型: "Type de message",
  消息内容: "Contenu du message",
  链接: "Lien",
  文本: "texte",
  清空: "Clair",
  评论成功: "Commentaire réussi",
  扫描二维码: "Scannez le code QR",
  转入: "transfert dans",
  收款: "Collection",
  任务下单中心: "Centre de commande de tâches",
  记录: "enregistrer",
  任务倒计时: "Compte à rebours des tâches",
  倒计时后自动放弃: "Abandonner automatiquement après le compte à rebours",
  业务码: "Code d'entreprise",
  选择商品分类: "Sélectionnez la catégorie de produit",
  可多选: "Plusieurs sélections possibles",
  加载分类中: "Chargement des catégories",
  暂无分类: "Pas encore de classement",
  产品类别: "Catégorie de produit",
  账户余额: "Solde du compte",
  立即结算: "Règlement immédiat",
  任务已自动放弃: "La tâche a été automatiquement abandonnée",
  商品分类: "Classement des produits",
  订单详情: "Détails de la commande",
  预计收益: "Revenu estimé",
  预计佣金收益: "Revenu de commission estimé",
  收益率: "Rendement",
  扣款账户: "Compte de débit",
  确认结算: "Confirmer le règlement",
  未选择: "Non sélectionné",
  请选择商品分类: "Veuillez sélectionner une catégorie de produit",
  下单成功: "Commande passée avec succès",
  下单失败: "La commande a échoué",
  请重试: "Veuillez réessayer",
  订单记录: "Dossier de commande",
  没有更多了: "pas plus",
  业务号: "Numéro d'entreprise",
  商品类型: "Type de produit",
  佣金收益: "revenus de commissions",
  待结算: "En attente de règlement",
  已结算: "Installé",
  已取消: "Annulé",
  加载失败: "Le chargement a échoué",
  倒计时: "Compte à rebours",
  随机商品: "objets aléatoires",
  为: "pour",
  商户助力可提升商品曝光度:
    "L'assistance des commerçants peut augmenter la visibilité du produit",
  累计助力越高推荐权重越高:
    "Plus l’assistance cumulée est élevée, plus le poids de recommandation est élevé.",
  实时助力动态: "Dynamique de l'assistance en temps réel",
  助力奖励: "Boostez les récompenses",
  随机奖励金额已生成: "Un montant de récompense aléatoire a été généré",
  开心收下: "Heureux de l'accepter",
  助力已结束: "L'aide est terminée",
  助力成功: "Aide au succès",
  成功: "succès",
  进行中: "En cours",
  等待: "attends",
  助力失败: "L'aide a échoué",
  任務: "Tâche",
  下单失败_请稍后重试: "La commande a échoué, veuillez réessayer plus tard",
  任务: "Tâche"
};
